import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, TextField, Typography } from '@mui/material';
import React from 'react'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditableAccordionHeader from '../components/EditableAccordionHeader';

function CustomerReview({ 
  reviewOpen, 
  setReviewOpen, 
  formData, 
  setFormData, 
  errors, 
  setErrors,
  // Heading editing props
  sectionHeading,
  isEditingHeading,
  tempHeadingValue,
  setTempHeadingValue,
  onEditHeading,
  onSaveHeading,
  onCancelHeading,
}) {
    return <Accordion expanded={reviewOpen} onChange={() => setReviewOpen(!reviewOpen)}>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panelCustomerReviews-content"
            id="panelCustomerReviews-header"
        >
            <EditableAccordionHeader
                sectionKey="customerSection"
                heading={sectionHeading}
                isEditing={isEditingHeading}
                tempValue={tempHeadingValue}
                setTempValue={setTempHeadingValue}
                onEdit={onEditHeading}
                onSave={onSaveHeading}
                onCancel={onCancelHeading}
            />
        </AccordionSummary>
        <AccordionDetails>
            <Grid container direction="row" spacing={3}>
                <Grid item xs={12} md={6}>
                    <Typography
                        variant="body2"
                        fontWeight="medium"
                        color="#9A9AAF"
                        mb={1}
                        name="customerReviews"
                        style={{ fontSize: "14px" }}
                    >
                        Section Title (H2)
                    </Typography>
                    <TextField
                        label=""
                        className="form-input"
                        fullWidth
                        placeholder=""
                        value={formData?.customerReviews}
                        error={Boolean(errors?.customerReviews)}
                        helperText={errors?.customerReviews}
                        onChange={(e) => {
                            setErrors((prev) => ({ ...prev, customerReviews: "" }));
                            setFormData((prev) => ({
                                ...prev,
                                customerReviews: e.target.value,
                            }));
                        }}
                    />
                </Grid>
            </Grid>
        </AccordionDetails>
    </Accordion>
}

export default CustomerReview